import { Component, ElementRef } from '@angular/core';
import { BaseDesignerComponent } from '../../base/base-designer-component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import {
  DesignAttributeType,
  OptionsAttribute,
  RuleAttribute,
  PageNavigationAttribute,
  AttributeChangeEventArgsType,
  FlowNavigationAttribute,
} from 'app/private/sxfdesigner/types/designer-attribute-type';
import { NonTransactionalFlowService } from 'app/infrastructure/services/non-transactional-flow.service';

@Component({
  selector: 'sx-actionbutton-designer',
  templateUrl: './actionbuttonDesigner.component.html',
})
export class SxActionButtonComponent extends BaseDesignerComponent {
  pageList: DesignerSelectItem[] = [];
  interactionRules: DesignerSelectItem[] = [];
  flowList: any;

  constructor(container: ElementRef, private nonTransactionalSrv: NonTransactionalFlowService) {
    super(container, 'SxActionButton');
  }

  loadDefaults(): void {
    super.loadDefaults();
    this.controlContext.ruleValue = '';
    this.controlContext.interactionEventValue = '';
    this.controlContext.label = 'Buton';
    this.controlContext.style = 'btn btn-primary';
    this.controlContext.causesValidation = true;
    this.controlContext.validationGroup = '';
  }

  getDesignerInfo(): any {
    const info = super.getDesignerInfo();
    info['ruleValue'] = this.controlContext.ruleValue;
    info['interactionEventValue'] =this.controlContext.interactionEventValue;
    info['navigateTo'] = this.controlContext.navigateTo;
    info['actionType'] = this.controlContext.actionType;
    info['label'] = this.controlContext.label;
    info['style'] = this.controlContext.style;
    info['causesValidation'] = this.controlContext.causesValidation;
    info['validationGroup'] = this.controlContext.validationGroup;
    info['navigateToFlow'] = this.controlContext.navigateToFlow;
    info['pageId'] = this.controlContext.pageId;
    return info;
  }

  buildAttributes(): void {
    super.buildAttributes();
    this.pageList = this.designerContext.product.pageList;
    this.flowList = this.designerContext.product.flowList;

    if (this.pageList != null) {
      this.pageList.forEach((element) => {
        element.description = element.id;
      });
    }

    this.interactionRules = this.designerContext.product.interactionRules;

    const label = new DesignAttributeType(
      this.controlContext,
      'string',
      'label',
      'Label'
    );
    const styles = [
      { id: 'btn btn-primary', name: 'Primary' },
      { id: 'btn btn-secondary', name: 'Secondary' },
      { id: 'default', name: 'Default' },
    ];

    const style = new OptionsAttribute(
      this.controlContext,
      styles,
      'style',
      'Style'
    );
    let actionTypes = [
      { id: 'executeRule', name: 'Execute Rule' },
      { id: 'interactionEvent', name: 'Non Blocking Interaction Event' },
      { id: 'navigation', name: 'Navigate' },
      { id: 'openModal', name: 'Open Modal' },
    ];

    if (this.designerContext.isNonTransactional) {
      actionTypes.push({ id: 'navigateToFlow', name: 'Navigate to flow' });

      const navigationNonTranAtt = new FlowNavigationAttribute(
        this.controlContext,
        this.flowList,
        'navigateToFlow',
        'Navigate To Flow'
      );
      navigationNonTranAtt.hiddenConditions = [
        ['actionType', '!=', 'navigateToFlow'],
      ];
      navigationNonTranAtt.change.subscribe((args) => this.onFlowChange(args));

      const selectedFlowPageList = new PageNavigationAttribute(
        this.controlContext,
        [],
        'pageId',
        'Navigate To'
      );
      selectedFlowPageList.hiddenConditions = [['actionType', '!=', 'navigateToFlow']];
      this.getFlowPages(this.controlContext.navigateToFlow);
      this.attributes.push(navigationNonTranAtt, selectedFlowPageList);
    }

    const actionTypesAtt = new OptionsAttribute(
      this.controlContext,
      actionTypes,
      'actionType',
      'Action Type'
    );
    const validates = new DesignAttributeType(
      this.controlContext,
      'boolean',
      'causesValidation',
      'Trigger Validators'
    );
    const validationGroupAtt = new DesignAttributeType(
      this.controlContext,
      'string',
      'validationGroup',
      'Validation Group'
    );
    style.change.subscribe((v) => this.onStyleAttChange(v));

    this.attributes.push(actionTypesAtt);
    const ruleValue = new RuleAttribute(
      this.controlContext,
      this.interactionRules,
      'ruleValue',
      'Rule Value'
    );
    ruleValue.hiddenConditions = [
      ['actionType', '!=', 'executeRule'],
    ];

    const interactionEventValue = new RuleAttribute(
      this.controlContext,
      this.interactionRules,
      'interactionEventValue',
      'Interaction Event'
    );
    interactionEventValue.hiddenConditions = [
      ['actionType', '!=', 'interactionEvent'],
    ];

    const navigationAtt = new PageNavigationAttribute(
      this.controlContext,
      this.pageList,
      'navigateTo',
      'Navigate To'
    );
    navigationAtt.hiddenConditions = [['actionType', '!=', 'navigation']];

    this.attributes.push(
      navigationAtt,
      ruleValue,
      interactionEventValue,
      label,
      style,
      validates,
      validationGroupAtt
    );
  }

  onFlowChange(args: AttributeChangeEventArgsType): void {
    if(args.oldValue !== args.newValue)
      this.getFlowPages(args.newValue)
  }

  getFlowPages(id: string): void {
    if(id){
      this.nonTransactionalSrv.getFlowPages(id).subscribe(pages => {
        const pageAtt = (this.attributes.find(att => att.name === 'pageId') as PageNavigationAttribute);
        pageAtt.options = pages.map(page => { return <DesignerSelectItem> {
          id: page.id,
          description: page.id
        }});
      });
    }
  }

  onStyleAttChange(args: AttributeChangeEventArgsType): void {
    this.controlContext.style = args.newValue;
  }

  onDemoClick() {
    return;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/actionbuttonDesigner.component.ts